import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.assign";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import staticQueryData from "../../public/static/d/2438170150.json";
import React from 'react';
import { StaticQuery } from 'gatsby';
import ListGroup from '../components/ListGroup';

var ApiNavigation =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ApiNavigation, _React$Component);

  function ApiNavigation() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ApiNavigation.prototype;

  _proto.filterItems = function filterItems(type) {
    return this.props.items.filter(function (item) {
      return item.node.parentPid === type;
    });
  };

  _proto.render = function render() {
    var selectedId = this.props.selectedId;
    return React.createElement("div", {
      className: "nav"
    }, React.createElement(ListGroup, {
      selectedId: selectedId,
      title: 'MODULES',
      items: this.filterItems('module')
    }), React.createElement(ListGroup, {
      selectedId: selectedId,
      title: 'EXTERNALS',
      items: this.filterItems('external')
    }), React.createElement(ListGroup, {
      selectedId: selectedId,
      title: 'CLASSES',
      items: this.filterItems('class')
    }), React.createElement(ListGroup, {
      selectedId: selectedId,
      title: 'NAMESPACES',
      items: this.filterItems('namespace')
    }), React.createElement(ListGroup, {
      selectedId: selectedId,
      title: 'MIXINS',
      items: this.filterItems('mixin')
    }), React.createElement(ListGroup, {
      selectedId: selectedId,
      title: 'TYPEDEF',
      items: this.filterItems('typedef')
    }), React.createElement(ListGroup, {
      selectedId: selectedId,
      title: 'GLOBAL',
      items: this.filterItems('global')
    }));
  };

  return ApiNavigation;
}(React.Component);

var NavigationWrapper = function NavigationWrapper(props) {
  return React.createElement(StaticQuery, {
    query: "2438170150",
    render: function render(data) {
      return React.createElement(ApiNavigation, Object.assign({
        items: data.allNavigationJson.edges
      }, props));
    },
    data: staticQueryData
  });
};

export default NavigationWrapper;